// This file is automatically generated. Do not edit manually.

import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { CustomerOrderState } from "src/api/generated/erp/db/types/enums/customerOrderState";
import { IsoDateTimeString } from "src/types/dateTime";
import { IsoDateString } from "src/types/dateTime";
import { CustomerPriceGroupPricingMethod } from "src/api/generated/io/aavo/applications/db/erp/types/customerPriceGroupPricingMethod";
import { CustomerOrderViewCustomerType } from "src/api/generated/erp/db/types/enums/customerOrderViewCustomerType";
import { Country } from "src/api/generated/io/aavo/applications/db/erp/types/country";
import { CustomerOrderViewPriceRecalculationStatus } from "src/api/generated/erp/db/types/enums/customerOrderViewPriceRecalculationStatus";
import { CustomerOrderViewSourceType } from "src/api/generated/erp/db/types/enums/customerOrderViewSourceType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderDataGridApi {
	export async function getSalesLeadCustomerOrders(args: {
		dataModelRequest?: ServerSideDataModelRequest;
		salesLeadId: number;
	}): Promise<ServerSideDataModelResult<CustomerOrderDataGridApi_CustomerOrderDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/getSalesLeadCustomerOrders",
			method: "POST",
			data: {
				dataModelRequest: args.dataModelRequest,
				salesLeadId: args.salesLeadId,
			},
		});
		return response as ServerSideDataModelResult<CustomerOrderDataGridApi_CustomerOrderDto>;
	}

	export async function searchCustomerOrders(args: {
		dataModelRequest?: ServerSideDataModelRequest;
		stateFilter?: Array<CustomerOrderState>;
		searchQuery?: string;
		customerOrderIdFilter?: number | null | undefined;
		onlyDefaultSiteOrders?: boolean;
		showInvoicedOrders?: boolean;
		showCancelledOrders?: boolean;
		tenantStateFilter?: string | null | undefined;
		responsiblePersonId?: number | null | undefined;
		showOnlyUnconfirmedOrders?: boolean;
		showOnlyFrozenOrders?: boolean;
		customerOrderTypeId?: number | null | undefined;
		salesLeadIdFilter?: number | null | undefined;
		customerIdFilter?: number | null | undefined;
		tenantSpecificFilters?: Record<string, string>;
	}): Promise<ServerSideDataModelResult<CustomerOrderDataGridApi_CustomerOrderDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/searchCustomerOrders",
			method: "POST",
			data: {
				dataModelRequest: args.dataModelRequest,
				stateFilter: args.stateFilter,
				searchQuery: args.searchQuery,
				customerOrderIdFilter: args.customerOrderIdFilter,
				onlyDefaultSiteOrders: args.onlyDefaultSiteOrders,
				showInvoicedOrders: args.showInvoicedOrders,
				showCancelledOrders: args.showCancelledOrders,
				tenantStateFilter: args.tenantStateFilter,
				responsiblePersonId: args.responsiblePersonId,
				showOnlyUnconfirmedOrders: args.showOnlyUnconfirmedOrders,
				showOnlyFrozenOrders: args.showOnlyFrozenOrders,
				customerOrderTypeId: args.customerOrderTypeId,
				salesLeadIdFilter: args.salesLeadIdFilter,
				customerIdFilter: args.customerIdFilter,
				tenantSpecificFilters: args.tenantSpecificFilters,
			},
		});
		return response as ServerSideDataModelResult<CustomerOrderDataGridApi_CustomerOrderDto>;
	}
}

export interface CustomerOrderDataGridApi_CustomerOrderDto {
	billingPlanIsComplete: boolean;
	customerOrderOfferId: number | null | undefined;
	tenantCustomColumn1: string | null | undefined;
	additionalAddress: string;
	approvedAt: IsoDateTimeString | null | undefined;
	approvedByUserId: number | null | undefined;
	automaticReservation: boolean;
	billingPlanEnabled: boolean;
	businessId: string | null | undefined;
	cancelledAt: IsoDateTimeString | null | undefined;
	cancelledByUserId: number | null | undefined;
	capacityReservation: boolean;
	checkedAt: IsoDateTimeString | null | undefined;
	checkedByUserId: number | null | undefined;
	confirmedAt: IsoDateTimeString | null | undefined;
	confirmedByUserId: number | null | undefined;
	consignmentPrintoutText: string;
	contactEmail: string;
	contactName: string;
	contactPhone: string;
	contractDate: IsoDateString | null | undefined;
	contractualTermCode: string | null | undefined;
	contractualTermContent: string | null | undefined;
	contractualTermId: number | null | undefined;
	costEventPriceListId: number | null | undefined;
	costEventPriceListName: string | null | undefined;
	createdByUserEmail: string;
	createdByUserId: number;
	createdByUserName: string;
	createdDate: IsoDateTimeString;
	currencyCode: string;
	currencyId: number;
	customerGroupId: number | null | undefined;
	customerGroupName: string | null | undefined;
	customerId: number;
	customerName: string;
	customerOrderId: number;
	customerOrderLongName: string | null | undefined;
	customerOrderState: CustomerOrderState;
	customerOrderTypeId: number;
	customerOrderTypeName: string;
	customerPoNo: string;
	customerPriceGroupId: number | null | undefined;
	customerPriceGroupPricingMethod: CustomerPriceGroupPricingMethod;
	customerType: CustomerOrderViewCustomerType;
	deliveredAt: IsoDateTimeString | null | undefined;
	deliveryAddress_1: string;
	deliveryAddress_2: string;
	deliveryCity: string;
	deliveryContact: string | null | undefined;
	deliveryCountry: Country;
	deliveryMethodCode: string;
	deliveryMethodId: number;
	deliveryName: string;
	deliveryNotes: string;
	deliveryPostalCode: string;
	deliveryPrintoutText: string;
	deliveryRecipientName: string;
	deliveryTermsCode: string;
	deliveryTermsDescription: string;
	deliveryTermsDestination: string;
	deliveryTermsId: number;
	externalOrderId: string | null | undefined;
	frozenAt: IsoDateTimeString | null | undefined;
	inputPricesWithVat: boolean;
	invoiceAddressAddress_1: string;
	invoiceAddressAddress_2: string;
	invoiceAddressCity: string;
	invoiceAddressContact: string | null | undefined;
	invoiceAddressCountry: Country;
	invoiceAddressEmail: string | null | undefined;
	invoiceAddressId: number;
	invoiceAddressName: string;
	invoiceAddressPhone: string | null | undefined;
	invoiceAddressPostalCode: string;
	invoicePrintoutText: string;
	isCancelled: boolean;
	lastUpdated: IsoDateTimeString;
	note: string | null | undefined;
	orderConfirmationPrintoutText: string;
	orderReference: string;
	paymentTerm: string;
	paymentTermDesc: string;
	paymentTermId: number;
	paymentTermPaymentDays: number;
	plannedDeliveryDate: IsoDateString;
	priceGroupName: string | null | undefined;
	priceRecalculationStatus: CustomerOrderViewPriceRecalculationStatus;
	relatedUrl: string | null | undefined;
	releasedAt: IsoDateTimeString | null | undefined;
	releasedByUserId: number | null | undefined;
	responsiblePersonCode: string;
	responsiblePersonId: number;
	responsiblePersonName: string;
	salesCommissionId: number | null | undefined;
	salesLeadId: number | null | undefined;
	salespersonEmail: string | null | undefined;
	salespersonId: number | null | undefined;
	salespersonName: string | null | undefined;
	siteId: number;
	siteName: string;
	sourceId: number | null | undefined;
	sourceType: CustomerOrderViewSourceType;
	tenantState: string | null | undefined;
	tenantStateChangedAt: IsoDateTimeString | null | undefined;
	transportDuration: number | null | undefined;
	transportRouteId: number | null | undefined;
	transportRouteName: string | null | undefined;
	vatCodeId: number;
	vatHandlingTypeId: number;
	vatHandlingTypeName: string;
	vatHandlingTypeVatPercent: number | null | undefined;
}
